<template>
    <span class="truncate">
        {{ params.data.adsetTitle }}
    </span>
</template>
<script>
export default {}
</script>
